import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCustomMatCheckbox]'
})
export class CustomMatCheckboxDirective implements AfterViewInit {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.customCheckbox();
  }

  customCheckbox() {
    const checkboxFrame = this.el.nativeElement.querySelector('.mat-checkbox-frame');
    this.renderer.addClass(checkboxFrame, 'active');
    this.renderer.setStyle(checkboxFrame, 'border-radius', '6px');
    this.renderer.setStyle(checkboxFrame, 'border', '2px solid #D0D5DD');
    this.renderer.setStyle(checkboxFrame, 'background', '#FFF');
    this.renderer.setStyle(checkboxFrame, 'width', '20px');
    this.renderer.setStyle(checkboxFrame, 'height', '20px');

    const matCheckboxLayout = this.el.nativeElement.querySelector('.mat-checkbox-layout');
    this.renderer.setStyle(matCheckboxLayout, 'margin', '0');

    const checkboxInnerContainer = this.el.nativeElement.querySelector('.mat-checkbox-inner-container');
    this.renderer.setStyle(checkboxInnerContainer, 'width', '20px');
    this.renderer.setStyle(checkboxInnerContainer, 'height', '20px');

    const matCheckboxCheckmarkPath = this.el.nativeElement.querySelector('.mat-checkbox-checkmark-path');
    this.renderer.setStyle(matCheckboxCheckmarkPath, 'stroke-width', '3px');

    const matCheckboxMixedmark = this.el.nativeElement.querySelector('.mat-checkbox-mixedmark');
    this.renderer.removeStyle(matCheckboxMixedmark, 'width');
    this.renderer.removeStyle(matCheckboxMixedmark, 'height');
    this.renderer.removeStyle(matCheckboxMixedmark, 'border-radius');
    this.renderer.setStyle(matCheckboxMixedmark, 'width', 'calc(100% - 9px)');
    this.renderer.setStyle(matCheckboxMixedmark, 'height', '2.4px');
    this.renderer.setStyle(matCheckboxMixedmark, 'border-radius', '3px');

    const matCheckboxRipple = this.el.nativeElement.querySelector('.mat-checkbox-ripple');
    this.renderer.removeClass(matCheckboxRipple, 'mat-checkbox-ripple');

  }

  @HostListener('click') onClick() {
    const checkboxFrame = this.el.nativeElement.querySelector('.mat-checkbox-frame');
    // this.renderer.addClass(checkboxFrame, 'box-shadow');
    // this.renderer.setStyle(checkboxFrame, 'box-shadow', '0px 0px 0px 4px rgba(6, 102, 235, 0.15)');
  }

}
